import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Mon Nov 05 2018
 * @author Tomáš Leity
 */
import * as React from 'react';
import { T } from '../../i18n/T';
import StyledSummary from './styled/StyledSummary';
import { BoxDefault } from '../../boxes/BoxDefault';
import Icon from '../../media/Icon/Icon';
export var Summary =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Summary, _React$Component);

  function Summary(props) {
    var _this;

    _classCallCheck(this, Summary);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Summary).call(this, props));
    _this.getRows = _this.getRows.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Summary, [{
    key: "render",
    value: function render() {
      var summary = React.createElement(StyledSummary, Object.assign({}, this.props), React.createElement("table", null, React.createElement("tbody", null, this.getRows())));
      return this.props.bordered ? React.createElement(BoxDefault, {
        boxDashboard: true
      }, summary) : summary;
    }
  }, {
    key: "getRows",
    value: function getRows() {
      return this.props.data.map(function (row, i) {
        return React.createElement("tr", {
          key: i
        }, React.createElement("td", null, React.createElement(T, {
          id: row.description
        })), React.createElement("td", null, row.value, row.iconProps && React.createElement(Icon, Object.assign({
          className: "ml1"
        }, row.iconProps))));
      });
    }
  }]);

  return Summary;
}(React.Component);